import { cents } from "byzantine";
import filters from "byzantine/src/filters";

export const DIALOG_PAGE_SIZE = 5;

export const getDialogWidth = ({
  m,
  l,
}: {
  m: boolean;
  l: boolean;
}): string => {
  if (l) return "1080px";
  if (m) return "800px";
  return "90vw";
};

export const formatPaymentAmount = ({
  amount,
  isCollect,
  showCollectAmounts,
}: {
  amount: number;
  isCollect: boolean;
  showCollectAmounts: boolean;
}): string => {
  if (amount === 0) {
    return "";
  }
  const formatted = filters.currency(cents(amount));
  if (showCollectAmounts) {
    return isCollect ? `+${formatted}` : `-${formatted}`;
  }
  return formatted;
};
